<div>
  <div
    #profileMenu
    class="dropdown is-right">
    <div
      class="dropdown-trigger"
      style="cursor: pointer"
      (click)="showHideProfileMenu(profileMenu)">
      <topo-avatar
        [imageUrl]="userProfile?.profilePhotoUrl"
        [name]="userProfile?.displayName"
      size="32"></topo-avatar>
    </div>
    <div
      class="dropdown-menu mr-2"
      id="profile-menu"
      role="menu">
      <div class="dropdown-content">
        <div
          fxLayout="row"
          fxLayoutAlign="space-around"
          class="my-2 pb-1">
          <topo-theme-switcher></topo-theme-switcher>
        </div>
        <div
          class="profile-data"
          fxLayout="column"
          fxLayoutAlign="center center">
          <topo-avatar
            [imageUrl]="userProfile?.profilePhotoUrl"
            [name]="userProfile?.displayName"
          size="72"></topo-avatar>
          <div class="name">{{ userProfile?.fullName }}</div>
          <div class="email">{{ userProfile?.emailAddress }}</div>
          <div class="mt-2">
            @if (userContext?.hasPermission(Permissions.UsersReadMyProfile)) {
              <a
                class="profile-link"
                (click)="profileClick(profileMenu)"
                >
                <span>{{ 'MANAGEMENT.MENU.EDIT-PROFILE' | translate }}</span>
              </a>
            }
          </div>
        </div>
        @if (languages?.length > 1) {
          <div>
            <div class="select is-primary">
              <select
                class="dropdown-item no-border"
                [(ngModel)]="selectedCultureCode"
                (ngModelChange)="languageSelected()">
                @for (lang of languages; track lang.uId) {
                  <option
                    [ngValue]="lang.cultureCode">
                    {{ getLanguageDisplay(lang) }}
                  </option>
                }
              </select>
            </div>
          </div>
        }
        <a
          class="dropdown-item body-small-500"
          (click)="logout()">
          <span>{{ 'MANAGEMENT.MENU.LOGOUT' | translate }}</span>
        </a>
        @if (userHasMultipleProfiles) {
          <div>
            <hr class="dropdown-divider" />
            <div class="select is-small mx-2 center">
              <select
                [(ngModel)]="selectedOrganization"
                (ngModelChange)="changeUserProfile()">
                @for (userOrganization of userOrganizations; track userOrganization.uId) {
                  <option
                    [ngValue]="userOrganization">
                    {{ userOrganization.organizationDisplayName }}
                  </option>
                }
              </select>
            </div>
          </div>
        }
        @if (hasBusinessUnits) {
          <div
            class="business-units"
            [ngClass]="{'disabled': !(businessUnits?.length > 0)}">
            <topo-business-unit-select
              [multiSelectionMode]="false"
              [selectedUIds]="selectedUnitUIds"
              [businessUnits]="businessUnits"
              [searchPlaceholder]="'MANAGEMENT.MENU.SEARCH' | translate"
              location="left"
              [alignRight]="true"
            (selectedChanged)="onBusinessUnitsSelectionChanged($event)"></topo-business-unit-select>
          </div>
        }
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          class="versionNumber is-link"
          (click)="showOpenSourceLicenses()">
          <span>{{ 'APP.VERSION' | translate }}</span>
          <span class="ml-1">{{ appVersionNumber }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<topo-user-profile></topo-user-profile>
<topo-open-source-licenses [isActive]="shouldShowOpenSourceLicenses"></topo-open-source-licenses>
